import { IonButtons, IonContent, IonHeader, IonMenuButton, IonPage, IonTitle, IonToolbar, IonButton,
   IonGrid,
   IonRow,
   IonCol,
   IonIcon,
   IonLabel
} from '@ionic/react';
import React, { useState } from 'react';
import { addCircleOutline, addCircleSharp } from 'ionicons/icons';
import { withRouter } from "react-router";
import './More.css';
import OpenMenuButton from "../../../components/OpenMenuButton";
import ServerService from '../../../services/Server';
import { modules } from "../../settings/modules/SelectModule";
import { useEffect } from 'react';
import { setAuthPersisted } from '../../../services/pinUtils';

const More: React.FC = () => {

 const name:string = "More";

 const server = new ServerService();
 const moduleCfg = server.moduleCfg;

 var rowId = 0;
 var cols: {}[];
 var cnt = 0;

 const [curTab, setCurTab] = useState(server.tabPageIdx);

useEffect(() => {
  setCurTab(curTab === "0" ? "1" : "0")
},[])

  return (
    <IonPage>
      <IonHeader>
        <IonToolbar>
          <IonButtons slot="start">
            <IonMenuButton />
            <OpenMenuButton />
          </IonButtons>
          <IonTitle>{name}</IonTitle>
        </IonToolbar>
      </IonHeader>

      <IonContent>
        <IonHeader collapse="condense">
          <IonToolbar>
            <IonTitle size="large">{name}</IonTitle>
          </IonToolbar>
        </IonHeader>

        <IonGrid>
          {moduleCfg[curTab].map((mid, i) => {
              if (cnt === 0) {
                cols = [];
              }
              var content;
              if (mid!==0 && mid!==3) {
                const module = modules[mid];
                content = (
                  <IonButton className="btn" onClick={() => {
                      server.tabPageIdx = curTab
                      server.nextTab = module.tab
                      server.saveTabPageIdx()
                      setAuthPersisted();
                      window.location.href = "/page/home";
                  }} size="large" color={mid!==0 ? "primary" : "success"}>
                  <div>
                  <IonIcon ios={mid!==0 ? module.iosIcon : addCircleOutline} md={mid!==0 ? module.mdIcon : addCircleSharp}></IonIcon><br/>
                  
                  <IonLabel className="lbl">{module.title}</IonLabel>
                  </div>
                  </IonButton>
                )
                cols.push(
                  <IonCol key={i} className="ion-text-center">
                  {content}
                  </IonCol>
                )
                cnt++
             }
             if (cnt === 2 || i === moduleCfg[curTab].length-1) {
              if (cnt === 1) {
                cols.push(
                  <IonCol key={i+1} className="ion-text-center">
                    <div className="btn">&nbsp;</div>
                  </IonCol>
                )
              }
              cnt = 0
              rowId++;
              return(<IonRow key={rowId}>
                <>
                {cols}
                </>
                </IonRow>)
            }
      })}
        </IonGrid>

      </IonContent>
    </IonPage>
  );
};

export default withRouter(More);
